import { gql } from '@apollo/client';
const PLAN_ORDER_COMPONENT_DELIVERIES = gql `
  mutation PlanOrderComponentDeliveries(
    $orderComponentVariantId: ID!
    $plannedDeliveries: [PlannedDeliveryInput!]!
  ) {
    planOrderComponentDeliveries(
      orderComponentVariantId: $orderComponentVariantId
      plannedDeliveries: $plannedDeliveries
    ) {
      orderComponentVariant {
        id
        deliveries {
          id
          deliveryType
          quantityPlanned
          quantityCollected
          plannedDate
          collectedDate
          timelineStartDate
          timelineEndDate
          status
          deliveryOrdinal
        }
      }
    }
  }
`;
export default PLAN_ORDER_COMPONENT_DELIVERIES;
